import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AppContext} from '../../../app.context';
import {MailboxOnboardingComponent} from '../../../onboarding/mailbox-onboarding.component';

@Component({
	selector: 'app-main',
	imports: [RouterOutlet, MailboxOnboardingComponent],
	standalone: true,
	host: { 'class': 'flex-1' },
	template: `
		<main class="pb-2 h-full">
			@if (ctx.appMode() === 'onboarding') {
				<app-mailbox-onboarding/>
			} @else {
				<router-outlet/>
			}
		</main>
	`,
	styleUrl: './main.component.css'
})
export class MainComponent {
	protected ctx = inject(AppContext)
}
